import { render, staticRenderFns } from "./groupYearReport.vue?vue&type=template&id=5d4c87bb&scoped=true&"
import script from "./groupYearReport.vue?vue&type=script&lang=js&"
export * from "./groupYearReport.vue?vue&type=script&lang=js&"
import style0 from "./groupYearReport.vue?vue&type=style&index=0&id=5d4c87bb&scoped=true&lang=css&"
import style1 from "./groupYearReport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4c87bb",
  null
  
)

export default component.exports